import { Experience } from 'utility/interfaces';
import Work from '@material-ui/icons/Work';
import School from '@material-ui/icons/School';

export const workExperience: Experience[] = [
    {
        company: 'SunRun',
        title: 'Senior Staff Engineer',
        description: 'Leading development on new projects within the AI org.',
        date: '10/2023 - Present',
        icon: Work,
    },
    {
        company: 'Optic',
        title: 'Staff Engineer',
        description: 'Life moves fast, Essense was acquired by Optic and i joined as as a Staff Engineer.',
        date: '04/2023 - 08/2023',
        icon: Work,
    },
    {
        company: 'Essense.io (Acquired by Optic)',
        title: 'Founder',
        description:
            'Essense empowers product owners to make data driven decisions based on user feedback. Effortlessly analyze thousands of reviews in minutes, and stay ahead of the competition. Get summarized feedback delivered daily right to your slack channel.',
        date: '03/2023 - Present',
        icon: Work,
    },
    {
        company: 'Stock Alarm (Acquired)',
        title: 'CTO',
        description: 'Took a leap of faith and went full-time on Stock Alarm. Still bootstrapped. At 170,000 users at the moment.',
        date: '07/2022 - 10/2023',
        icon: Work,
    },
    {
        company: 'Amazon',
        title: 'Software Development Engineer II',
        description: `Owner of a variety of initiatives impacting Amazon's checkout platform worldwide on all devices from the points of security, latency, and reliability.`,
        date: '07/2021 - 07/2022',
        icon: Work,
    },
    {
        company: 'Amazon',
        title: 'Software Development Engineer',
        description:
            'Developed core infrastructure for context aware requests that access sensitive user data. Lead developer on an S-Team goal empowering multi-year commitments between Amazon & its vendors. Developed internal tooling for Amazon employees to manage purchase order life-cycles.',
        date: '06/2020 - 07/2021',
        icon: Work,
    },
    {
        company: 'Stock Alarm',
        title: 'Head of Growth',
        description:
            'Working with a small team to help thousands of stock market traders every day. Stock Alarm provides over 70 realtime alert types on 15k+ stock & crypto tickers. Currently at +$20K MRR, 34K MAU, 4.8 stars, 4K+ ratings on the appstore.',
        date: '11/2019 - Present',
        icon: Work,
    },
    {
        company: 'Boston University',
        title: 'University Graduate',
        description: 'Graduated Magna Cum Laude from Boston University with a computer engineering degree and a cumulative GPA of 3.72',
        date: '05/2020',
        icon: School,
    },
    {
        company: 'Bank of America, Merrill Lynch',
        title: 'Global Technology Summer Analyst',
        description:
            'Worked in the Benefits Online division as a C# .NET developer, Anyone who has a 401(K) with Merrill Lynch utilizes investment direction functionality that I designed & implemented to manage their future investment allocation.',
        date: '06/2019 - 09/2019',
        icon: Work,
    },
    {
        company: 'Boston University',
        title: 'Teaching Assistant',
        description:
            'Teaching assistant for 2 undergraduate courses and 2 graduate courses over a 2 year period (1 per semester). Courses were EC311: Introduction to logic design, EC330: Applied algorithms & data structures, EC504: Advanced data structures, EC526: Parallel Algorithms for high performance computing',
        date: '09/2018 - 09/2020',
        icon: School,
    },
    {
        company: 'Libring Technologies (Acquired by App Annie)',
        title: 'Software Engineering Intern',
        description:
            'SWE intern at libring where i got to build some awesome stuff including: Designing a Python Discord bot coupled with a unique permissions system to allow non-tech savvy employees to be able to run reporting operations on remote servers, Automated server reporting & MySQL database backups to a remote GCS Bucket. Implemented web-hooks to allow tracking of customer & end-user platform interactions, Automated weekly & monthly KPI data collection from sources including but not limited to: Google Analytics, Hubspot API, Marketing MySQL Database, Jira API, and a variety of Google Cloud APIs.',
        date: '01/2019 - 05/2019',
        icon: Work,
    },
    {
        company: 'Libring Technologies (Acquired by App Annie)',
        title: 'System Integration Intern',
        description:
            "Tasked with the project of digital System Integration. The project's main goal is to connect several digital internal systems using knowledge of Database Schema, Python Scripting, and API calls.\n\r Worked with RESTful APIs and a MySQL Database to integrate marketing automation and CRM software for an automated & scalable system in the CentOs Linux environment.- Automated weekly KPI data collection from various internal endpoints.",
        date: '01/2019 - 05/2019',
        icon: Work,
    },
];
